import React, { useEffect, useState } from 'react';

import { Outlet, useLocation } from 'react-router-dom';
import Header from '../ui/Header';
import SideNav from '../ui/SideNav';
import { wrap, body, contentsWrap } from './style';

function Main() {
  const { pathname } = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [pathname]);

  return (
    <main css={wrap}>
      <SideNav
        isDrawerOpen={isDrawerOpen}
        onCloseDrawer={() => setIsDrawerOpen(false)}
      />
      <div css={body}>
        <Header onOpenMenu={() => setIsDrawerOpen(true)} />
        <section css={contentsWrap}>
          <div>
            <Outlet />
          </div>
        </section>
      </div>
    </main>
  );
}

export default Main;
